import { DeleteButton } from "react-admin";

const AttachmentDeleteButton = ({ basePath, record, resource, path, relatedId, ...props }) => {

    const appendedBasePath = `${resource}/${path}/${relatedId}`
    return <DeleteButton basePath={basePath} record={record} resource={appendedBasePath} {...props} />
}

export default AttachmentDeleteButton;